<template>
    <div>
        <div class="time text-center text-color-primary">{{ timeString }}</div>
        <div class="greeting text-center text-color-primary">
            Good {{ period }},
            <span class="cursor-pointer" @click="changeUserName">{{ userName }}</span>.
        </div>
        <FocusForm id="focus-form"/>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { getTime } from "@/util";
import FocusForm from "@/components/FocusForm.vue";

export default {
  name: "HomeView",
  components: { FocusForm },
  data: () => ({
        time: {},
        interval: null
  }),
  computed: {
        ...mapState(["userName"]),
        timeString() {
            return `${this.time.hour}:${this.time.minute}`;
        },
        period() {
            const { hour } = this.time;
            if (hour >= 0 && hour <= 11) {
                return "morning";
            } else if (hour >=12 && hour <= 18 ) {
                return "afternoon";
            } else {
                return "evening";
            }
        }
    },
    methods: {
        setTime() {
            const temp = getTime();
            const hour = temp.getHours();
            const minute = temp.getMinutes() < 10 ? `0${temp.getMinutes()}` : temp.getMinutes();
            this.time = { hour, minute };
        },
        changeUserName() {
            this.$router.push("/welcome");
        }
    },
    created() {
        this.setTime();
        // update time every one minute
        this.interval = setInterval(this.setTime, 60000);
    },
    destroyed() {
        // clear the timer
        clearInterval(this.interval);
    }
}
</script>

<style scoped>
.time { font-size: 8rem; }
.greeting { font-size: 4rem; }

#focus-form {
    transform: translate(-50%, -50%);
    position: absolute;
    top: 150%;
    left: 50%;
}
</style>
